<template>
  <legal-page :content="content" />
</template>

<script>
import LegalPage from '../LegalPage.vue';
import rawMd from './terms.md';

export default {
  name: 'TermsPage',
  components: { LegalPage },
  data() {
    return { content: rawMd };
  }
};
</script>
